import { scrollToElement, scrollWindowToElement } from 'scroll-element'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'

export default class Navigation {
    constructor() {
        this.init()
        this.cacheDom()
        this.bindEvents()
    }

    cacheDom() {
        this.bodyEl = document.body
        this.menuToggle = document.querySelector('.site-header__mobile-navToggle')
        this.links = document.querySelectorAll('.navigation__link')
        this.nav = document.querySelector('.navigation')
    }

    bindEvents() {
        this.menuToggle.addEventListener('click', this.handle.bind(this))

        if (!isNull(this.links)) {
            Array.prototype.forEach.call(this.links, (el, i) => {
                el.addEventListener('click', this.handleLinks.bind(this))
            })
        }
    }

    init() {
        const hash = window.location.hash.substr(1)

        if (!isEmpty(hash)) {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 1)

            const anchorEl = document.getElementById(hash)

            if (!isNull(anchorEl)) {
                scrollWindowToElement(anchorEl, 500, -100)
            }
        }
    }

    handle() {
        if (!this.nav.classList.contains('active')) {
            window.scrollTo(0, 0)
        }

        this.bodyEl.classList.toggle('overflow-hidden')
        this.nav.classList.toggle('active')
    }

    handleLinks(e) {
        e.preventDefault()
        const parent = e.target.parentNode
        const link = e.target.getAttribute('href')

        if (!parent.classList.contains('anchor') || !this.bodyEl.classList.contains('home')) {
            window.location.href = link
        }

        const hash = link.split('#').pop()
        const anchorEl = document.getElementById(hash)

        if (this.nav.classList.contains('active')) {
            this.bodyEl.classList.remove('overflow-hidden')
            this.nav.classList.remove('active')
        }

        if (!isNull(anchorEl)) {
            scrollWindowToElement(anchorEl, 500, -100)
        }
    }
}